module.exports = __webpack_public_path__ + "img/icon_search-g.f5999f0f.svg";